import { render, staticRenderFns } from "./Freelancers.vue?vue&type=template&id=d89784c4&scoped=true"
import script from "./Freelancers.vue?vue&type=script&lang=js"
export * from "./Freelancers.vue?vue&type=script&lang=js"
import style0 from "./Freelancers.vue?vue&type=style&index=0&id=d89784c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89784c4",
  null
  
)

export default component.exports